import { render, staticRenderFns } from "./BackTop.vue?vue&type=template&id=b3ef2724&scoped=true&"
import script from "./BackTop.vue?vue&type=script&lang=ts&"
export * from "./BackTop.vue?vue&type=script&lang=ts&"
import style0 from "./BackTop.vue?vue&type=style&index=0&id=b3ef2724&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ef2724",
  null
  
)

export default component.exports